module.exports = __webpack_public_path__ + "app/widgets/multi-select/multi-select-2cUO5_2B.html";